"use client";
import React, { useState, useEffect } from "react";

export default function MobileBottomBar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 400);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className={`md:hidden fixed bottom-0 left-0 right-0 z-50 transition-transform duration-500 ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <div className="mobile-cta-bar bg-linen/95 backdrop-blur-md border-t border-fog/60 px-4 py-4 flex items-center gap-3">
        <a
          href="https://wa.link/a6acna"
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 bg-amber text-linen text-sm font-medium py-3.5 rounded-xl text-center hover:bg-amber-hover transition-colors"
        >
          Book Consultation
        </a>
        <a
          href="#properties"
          className="flex-shrink-0 border border-fog/60 text-pine text-sm font-medium px-4 py-3.5 rounded-xl hover:bg-fog/20 transition-colors whitespace-nowrap"
        >
          View Properties
        </a>
      </div>
    </div>
  );
}